import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { EventRegistertionAsync, getAllEventsAsync, getAllEventsWithDatesAsync, getEventByIdAsync, getEventPublicAccessInfoAsync, getEventRegistrationInfoAsync, getExternalInvitationCountAsync, validateInitialRegistrationAsync, validatePublicPasswordAsync, verifyUniqueLinkAsync } from "./EventThunk";
const initialState = {
    status: APIStatus.IDLE,
    events: [],
    eventsWithDates: [],
    selectedEvent: null,
    externalInvitationCount: 0,
    singleEvent: null,
    publicAccessInfo: null,
    validationResponse: null,
    initialRegistrationValidation: null,
    registrationInfo: null,
    linkVerification: null
};
export const eventSlice = createSlice({
    name: "event",
    initialState,
    reducers: {
        clearPublicAccessInfo: (state) => {
            state.publicAccessInfo = null;
        },
        clearValidationResponse: (state) => {
            state.validationResponse = null;
        },
        clearInitialRegistrationValidation: (state) => {
            state.initialRegistrationValidation = null;
        },
        clearRegistrationInfo: (state) => {
            state.registrationInfo = null;
        },
        clearLinkVerification: (state) => {
            state.linkVerification = null;
        },
        clearEventState: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(EventRegistertionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        });
        builder.addCase(EventRegistertionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.FAILED;
            state.RegistrationResponse = action.payload;
        });
        builder.addCase(EventRegistertionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllEventsWithDatesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEventsWithDatesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.events = action.payload;
        })
            .addCase(getAllEventsWithDatesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllEventsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEventsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.events = action.payload;
        })
            .addCase(getAllEventsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getExternalInvitationCountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getExternalInvitationCountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalInvitationCount = action.payload;
        })
            .addCase(getExternalInvitationCountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEventByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.singleEvent = action.payload;
        })
            .addCase(getEventByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEventPublicAccessInfoAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventPublicAccessInfoAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.publicAccessInfo = action.payload;
        })
            .addCase(getEventPublicAccessInfoAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(validatePublicPasswordAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.validationResponse = null;
        })
            .addCase(validatePublicPasswordAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.validationResponse = action.payload;
        })
            .addCase(validatePublicPasswordAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(validateInitialRegistrationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.initialRegistrationValidation = null;
        })
            .addCase(validateInitialRegistrationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.initialRegistrationValidation = action.payload;
        })
            .addCase(validateInitialRegistrationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEventRegistrationInfoAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.registrationInfo = null;
        })
            .addCase(getEventRegistrationInfoAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.registrationInfo = action.payload;
        })
            .addCase(getEventRegistrationInfoAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(verifyUniqueLinkAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.linkVerification = null;
        })
            .addCase(verifyUniqueLinkAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.linkVerification = action.payload;
        })
            .addCase(verifyUniqueLinkAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    },
});
export const { clearEventState, clearPublicAccessInfo, clearValidationResponse, clearInitialRegistrationValidation, clearLinkVerification, clearRegistrationInfo } = eventSlice.actions;
export default eventSlice.reducer;
